import PrizeDisplay from './PrizeDisplay'
export default PrizeDisplay